import { StylesConfig } from "react-select";
import { _window } from "../../app-constants";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  BTapiUrl: process.env.REACT_APP_BT_BASE_URL,
  BTpublishableKey: process.env.REACT_APP_BT_PUBLISHABLE_KEY,
  BTproductId: process.env.REACT_APP_BT_PRODUCT_ID,
  BTaffiliatedId: process.env.REACT_APP_BT_AFFILIATED_ID,
  isSandBoxMode: parseInt(process.env.REACT_APP_BT_IS_SANDBOX || "0"),
  UKTelephone: _window?.BFPlugin?.bt?.Telephone || "+44 (78) 2202 7401",
  EUTelephone: _window?.BFPlugin?.bt?.Telephone || "+(32) 2881 0125",
  UKEmail: _window?.BFPlugin?.bt?.Email || "businesstravel@battleface.com",
  EUEmail: _window?.BFPlugin?.bt?.Email || "businesstravel@battleface.com",
};

// Displaying only the partner logo and text note for this specific partner.
export const showPartnerLogoAndTextNote = ["901"];

export const btCurrencyProductIds = {
  BTGBPProductId: process.env.REACT_APP_BT_GBP_PRODUCT_ID,
  BTEURProductId: process.env.REACT_APP_BT_EUR_PRODUCT_ID,
  BTUSDProductId: process.env.REACT_APP_BT_USD_PRODUCT_ID,
  BTEUProductId: process.env.REACT_APP_EU_PRODUCT_ID,
};

export const hideEUHostCountries = ["Croatia", "Hungary", "Portugal"];

export const noOfEmployee = [
  { value: "2-10", label: "2-10" },
  { value: "11-25", label: "11-25" },
  { value: "26-50", label: "26-50" },
  { value: "50-99", label: "50-99" },
  { value: "100+", label: "100+" },
];

export const currencyDropDown = [
  {
    value: "GBP",
    label: "GBP",
  },

  {
    value: "EUR",
    label: "EUR",
  },

  {
    value: "USD",
    label: "USD",
  },
];

// DD/MM/yyyy
export const formatTripDates = (date: Date | null) => (date ? date.toLocaleDateString("en-GB") : "");

export const businessTravelUKDocs: { [Key: string]: string } = {
  privacyPolicy: _window?.BFPlugin?.bt?.privacyPolicy || "https://www.battleface.com/en-gb/privacy-policy",
  termsAndConditions: _window?.BFPlugin?.bt?.termsAndConditions || "https://www.battleface.com/en-gb/terms-conditions",
  cookiePolicy: _window?.BFPlugin?.bt?.cookiePolicy || "https://www.battleface.com/en-gb/cookie-policy",
  insuranceDisclosure:
    _window?.BFPlugin?.bt?.insuranceDisclosure ||
    "https://www.battleface.com/documents/important-notices-and-disclosures-business-travel-medical.pdf",
  customerCharter:
    _window?.BFPlugin?.bt?.customerCharter ||
    "https://documents.battleface.com/other/business-travel---hamilton---uk---usd-customer-charter.pdf",
  IPID:
    _window?.BFPlugin?.bt?.IPID ||
    "https://documents.battleface.com/other/business-travel---hamilton---uk---usd-ipid.pdf",
};

export const businessTravelDocs: { [Key: string]: string } = {
  customQuote: _window?.BFPlugin?.bt?.customQuote || "https://www.battleface.com/en-gb/business-group-application",
  excludedDestinations:
    _window?.BFPlugin?.bt?.excludedDestinations ||
    `Afghanistan, Belarus, Central African Republic, Chechnya, Crimea, Democratic Republic of Congo, Cuba,
          Iran, Iraq, Israel, Lebanon, Libya, Nigeria, North Korea, Palestine, Russian Federation, Somalia, South Sudan,
          Sudan, Syria, Ukraine, Venezuela and Yemen.`,
  importantNote: _window?.BFPlugin?.bt?.importantNote || "",
  warningMessage:
    _window?.BFPlugin?.bt?.warningMessage ||
    "You have a duty to take reasonable care to answer questions fully and accurately. This duty exists when applying for cover and throughout the entire duration of the insurance.",
  governmentTravelAdvisory:
    _window?.BFPlugin?.bt?.governmentTravelAdvisory ||
    "This insurance product covers destinations worldwide, including countries under government essential   and non-essential travel advisories. For the latest travel advice please visit your local government website.",
};

export const PreviewPolicyUK: any = {
  USD:
    _window?.BFPlugin?.bt?.USDPreviewPolicy ||
    "https://documents.battleface.com/policy/business-travel---hamilton---uk---usd-policy.pdf",
  EUR:
    _window?.BFPlugin?.bt?.EURPreviewPolicy ||
    "https://documents.battleface.com/policy/business-travel---hamilton---uk---eur-policy.pdf",
  GBP:
    _window?.BFPlugin?.bt?.GBPPreviewPolicy ||
    "https://documents.battleface.com/policy/business-travel---hamilton---uk---gbp-policy.pdf",
};

export const businessTravelEUDocs: { [Key: string]: string } = {
  privacyPolicy: _window?.BFPlugin?.bt?.privacyPolicy || "https://www.battleface.com/en-eu/privacy-policy",
  termsAndConditions: _window?.BFPlugin?.bt?.termsAndConditions || "https://www.battleface.com/en-eu/terms-conditions",
  cookiePolicy: _window?.BFPlugin?.bt?.cookiePolicy || "https://www.battleface.com/en-eu/cookie-policy",
  insuranceDisclosure:
    _window?.BFPlugin?.bt?.insuranceDisclosure ||
    "https://documents.battleface.com/other/insurance-disclosure---eu.pdf",
  customerCharter:
    _window?.BFPlugin?.bt?.customerCharter || "https://documents.battleface.com/other/customer-charter---eu.pdf",
  IPID:
    _window?.BFPlugin?.bt?.IPID || "https://documents.battleface.com/other/business-travel---hamilton---eu---ipid.pdf",
};

export const PreviewPolicyEU: any = {
  USD:
    _window?.BFPlugin?.bt?.USDPreviewPolicy ||
    "https://documents.battleface.com/policy/business-travel---hamilton---eu---usd-policy.pdf",
  EUR:
    _window?.BFPlugin?.bt?.EURPreviewPolicy ||
    "https://documents.battleface.com/policy/business-travel---hamilton---eu---eur-policy.pdf",
  GBP:
    _window?.BFPlugin?.bt?.GBPPreviewPolicy ||
    "https://documents.battleface.com/policy/business-travel---hamilton---eu---gbp-policy.pdf",
};

export const benefitSummaryTableEU = [
  {
    name: "Medical Expenses, Repatriation and Emergency Travel Expenses",
    benefit: "10000000",
    description:
      "Coverage for bodily injury following an accident or illness in respect of medical expenses, repatriation and emergency travel expenses which are necessarily incurred as a direct result.",
  },
  {
    name: "Cancellation, Curtailment, Replacement and Change of Itinerary",
    benefit: "5000",
    description:
      "Coverage if the insured person or company is forced to cancel a journey, curtail a journey, replace an insured person on a journey or rearrange to resume a journey.",
  },
  {
    name: "Baggage, Delayed Baggage and Business Equipment",
    benefit: "5000",
    description: "Coverage for lost damaged stolen or destroyed baggage during a journey.",
  },

  {
    name: "Money, Passport and Credit Cards",
    benefit: "2000",
    description:
      "Coverage for lost money, travellers’ cheques, driving licences, and travel tickets, or financial loss as a result of a credit card being stolen or lost.",
  },
  {
    name: "Personal Accident Lump Sum Benefit",
    benefit: "100000",
    description:
      "Coverage for accidental death and permanent total disability in the event of an accident whilst travelling.",
  },
  {
    name: "Personal Accident weekly benefit 1 *",
    benefit: "250 per week payable up to 104 weeks, excluding the first 07 days",
    description: "Coverage for temporary total disability in the event of an accident whilst travelling.",
  },
  {
    name: "Personal Accident weekly benefit 2 **",
    benefit: "125 per week payable up to 104 weeks, excluding the first 07 days",
    description: "Coverage for temporary partial disability in the event of an accident whilst travelling.",
  },

  {
    name: "Legal Expenses / Personal Liability",
    benefit: "50000/5000000",
    description: "Coverage up to agreed limits for legal expenses and personal liability.",
  },

  {
    name: "Hijack, Kidnap and Detention",
    benefit: "250000",
    description: "Coverage for unlawful seizure and containment of the insured person.",
  },
  {
    name: "Evacuation",
    benefit: "50000",
    description: "Coverage for expenses incurred in the event of an emergency evacuation.",
  },
  {
    name: "Personal Security Specialist Expenses",
    benefit: "10000",
    description: "Coverage for costs incurred to employ security services following a life-threatening situation",
  },
  {
    name: "Corporate Event Cover",
    benefit: "25000",
    description:
      "Coverage for guests of the company sustaining bodily Injury or death following an accident whilst on any corporate event",
  },
];
export const benefitSummaryTableUK = [
  {
    name: "Medical Expenses, Repatriation and Emergency Travel Expenses",
    benefit: "10000000",
    description:
      "Coverage for bodily injury following an accident or illness in respect of medical expenses, repatriation and emergency travel expenses which are necessarily incurred as a direct result.",
  },
  {
    name: "Cancellation, Curtailment, Replacement and Change of Itinerary",
    benefit: "5000",
    description:
      "Coverage if the insured person or company is forced to cancel a journey, curtail a journey, replace an insured person on a journey or rearrange to resume a journey.",
  },
  {
    name: "Baggage, Delayed Baggage and Business Equipment",
    benefit: "5000",
    description: "Coverage for lost damaged stolen or destroyed baggage during a journey.",
  },

  {
    name: "Money, Passport and Credit Cards",
    benefit: "2000",
    description:
      "Coverage for lost money, travellers’ cheques, driving licences, and travel tickets, or financial loss as a result of a credit card being stolen or lost.",
  },
  {
    name: "Personal Accident Lump Sum Benefit",
    benefit: "100000",
    description:
      "Coverage for accidental death and permanent total disability in the event of an accident whilst travelling.",
  },
  {
    name: "Personal Accident weekly benefit 1 *",
    benefit: "250 per week payable up to 104 weeks, excluding the first 07 days",
    description: "Coverage for temporary total disability in the event of an accident whilst travelling.",
  },
  {
    name: "Personal Accident weekly benefit 2 **",
    benefit: "125 per week payable up to 104 weeks, excluding the first 07 days",
    description: "Coverage for temporary partial disability in the event of an accident whilst travelling.",
  },

  {
    name: "Legal Expenses / Personal Liability",
    benefit: "50000/5000000",
    description: "Coverage up to agreed limits for legal expenses and personal liability.",
  },

  {
    name: "Hijack, Kidnap and Detention",
    benefit: "250000",
    description: "Coverage for unlawful seizure and containment of the insured person.",
  },
  {
    name: "Evacuation",
    benefit: "50000",
    description: "Coverage for expenses incurred in the event of an emergency evacuation.",
  },
  {
    name: "Personal Security Specialist Expenses",
    benefit: "10000",
    description: "Coverage for costs incurred to employ security services following a life-threatening situation",
  },
  {
    name: "Corporate Event Cover",
    benefit: "25000",
    description:
      "Coverage for guests of the company sustaining bodily Injury or death following an accident whilst on any corporate event",
  },
];

// for react select dropdown options styling
export const colourStyles: StylesConfig<any> = {
  option: (styles, { isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isDisabled ? undefined : isSelected ? "#F4F4F4" : isFocused ? "#F4F4F4" : undefined,
      color: isSelected ? "black" : undefined,
      ":active": {
        ...styles[":active"],
        backgroundColor: isSelected ? "#F4F4F4" : "#F4F4F4",
      },
    };
  },
};

export const getProduct = (currency: string) => {
  switch (currency) {
    case "GBP":
      return btCurrencyProductIds.BTGBPProductId;
    case "EUR":
      return btCurrencyProductIds.BTEURProductId;
    default:
      return btCurrencyProductIds.BTUSDProductId;
  }
};

export const showPartnerLogoAndText = (partnerId: string, version: string) => {
  switch (partnerId) {
    case "1":
      return false;
    case "901":
      if (version === "EU") {
        return false;
      }
      return true;
    default:
      return true;
  }
};
